'use client';

import { LazyLottie } from './LazyLottie';
import { IAnimationProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation as a shown when the user performs a search that
 * doesn't return any results.
 */
export function ContentMissingAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import('./raw-animation-data/empty/content-missing-green.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="ContentMissingAnimation"
    />
  );
}
